import React, { useState, useLayoutEffect } from 'react';
import styled, { css } from 'styled-components';
import { MobileMenu } from '../MobileMenu';
import { BurgerButton } from './BurgerButton';
import { AnchorLink } from 'gatsby-plugin-anchor-links';
import { ClassroomButton } from './ClassroomButton';
import { Logo } from './LinkLogo';
import { mobileMQ } from './media-utils';
import { useSiteMetadata } from './useSiteMetadata';

const contactData = [
    { data: 'student@kespa.ru', type: 'mailto' },
    { data: '+7 (499) 647-60-44', type: 'tel' },
];

const MenuInnerContainer = styled.div`
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: flex-end;
    margin: 3px 0 0 32px;
    .logInBtn {
        margin-top: -4px;
    }
`;

const MenuList = styled.ul`
    display: flex;
    list-style: none;
    padding: 0;

    &.contacts {
        margin-left: auto;

        li:first-child {
            margin-right: 32px;
        }

        li:last-child {
            margin-right: 32px;
        }
    }
`;

const MenuItemLink = styled.li`
    height: 100%;
    margin-right: 16px;

    :hover {
        cursor: pointer;
    }

    &:last-child {
        margin-right: 0;
    }
`;

const MenuLink = styled(AnchorLink)`
    font-family: 'Circe Web';
    font-size: 18px;
    line-height: 100%;
    display: inline-block;
    padding: 2px 0;
    box-sizing: border-box;
    color: ${props => props.color};

    &:hover {
        color: #0b9cdb;
    }
`;

const MenuLinkSide = styled.a`
    font-family: 'Circe Web';
    font-size: 18px;
    line-height: 100%;
    display: inline-block;
    padding: 2px 0;
    box-sizing: border-box;
    color: ${props => props.color};

    &:hover {
        color: #0b9cdb;
    }
`;

const StyledButtonWrapper = styled.div`
    position: relative;
    top: -4px;
`;

const MobileView = styled.div`
    display: none;
    @media screen and (max-width: 1023px) {
        display: inherit;
    }
`;
const DesktopView = styled.div`
    display: none;
    @media screen and (min-width: 1024px) {
        display: flex;
        justify-content: space-between;
        width: 100%;
    }
`;

const MenuItem = ({ to, children, color, side }) => (
    <MenuItemLink>
        {side ? (
            <MenuLinkSide color={color} href={to}>
                {children}
            </MenuLinkSide>
        ) : (
            <MenuLink color={color} to={to}>
                {children}
            </MenuLink>
        )}
    </MenuItemLink>
);

export const Menu = ({ color, hideItems, menu }) => {
    const { menuData: defaultMenuData } = useSiteMetadata();

    const menuData = menu ? menu : defaultMenuData;
    const [isOpen, setOpen] = useState(false);
    useLayoutEffect(() => {
        if (document.body && isOpen) {
            document.body.style.overflowY = 'hidden';
            document.body.style.height = '100vh'; //fix no-scrol for safari
            document.body.style.width = '100vw'; //fix no-scrol for safari
            document.body.style.position = 'fixed'; //fix no-scrol for safari
            return () => {
                if (document.body) {
                    document.body.style.overflowY = 'initial';
                    document.body.style.height = 'initial';
                    document.body.style.position = 'initial';
                }
            };
        }
    }, [isOpen]);
    return (
        <MenuInnerContainer>
            <MobileView>
                <BurgerButton toggle={() => setOpen(!isOpen)} color={color} />
                <MobileMenu
                    isOpen={isOpen}
                    close={setOpen}
                    menuData={menuData}
                    contactData={contactData}
                    hideItems={hideItems}
                />
            </MobileView>
            <DesktopView>
                <MenuList>
                    {!hideItems &&
                        menuData.map(({ title, link }, i) => (
                            <MenuItem color={color} key={i} to={link}>
                                {title}
                            </MenuItem>
                        ))}
                </MenuList>
                <MenuList className="contacts">
                    {contactData.map(({ data, type }, i) => (
                        <MenuItem
                            color={color}
                            key={i}
                            to={`${type}:${data}`}
                            side
                        >
                            {data}
                        </MenuItem>
                    ))}
                </MenuList>
                <StyledButtonWrapper>
                    <ClassroomButton />
                </StyledButtonWrapper>
            </DesktopView>
        </MenuInnerContainer>
    );
};

const MenuWrap = styled.div`
    padding: 16px 0;
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '35px'};
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;

    ${mobileMQ(css`
        margin-bottom: 8px;
    `)}
`;

export const WrappedMenu = ({ ...props }) => {
    return (
        <MenuWrap {...props}>
            <Logo height="32" color="black" />
            <Menu color="black" />
        </MenuWrap>
    );
};
